const qualifications = [
  "Microsoft - Advanced programming in C#",
  "BCS - Level 4 diploma in software development",
  "BCS - Level 4 diploma in software development methodologies",
  "TQUK - Principles of Team Leading",
];

export { qualifications };
